<div>
    <div style="text-align: center; font-size: initial; color: #021F4E;">
        {{'PAYMENT_PAGES.PLEASE_SIGN_HERE'|translate}}
    </div>
    <div class="flex justify-content-center my-4">
        <canvas #signatureCanvas width="280" style="background: #e5e4e4;"></canvas>

        <button style="border-radius: 0;" pButton icon="pi pi-trash" [pTooltip]="'GENERAL.DELETE' | translate"
            tooltipPosition="right" (click)="clear()"></button>
    </div>
    <div class="flex justify-content-center">
        <button *ngIf="showSaveButton" pButton [label]="'GENERAL.SAVE' | translate" (click)="save()"></button>
    </div>
</div>